import {observable} from 'mobx';
import Cookies from 'js-cookie';

const token = Cookies.get('snail_token');
let menu = [];
try {
  menu = !!Cookies.get('CLS_SNAIL_CUSTOMER_CMS_MENU') ? JSON.parse(Cookies.get('CLS_SNAIL_CUSTOMER_CMS_MENU')) : [];
} catch(e) {
}

const Store = observable({
  token: token || '',
  menu: menu || [],
  setToken(value) {
    this.token = value;
  },
  setMenu(value) {
    let storeMenu = [];
    try {
      storeMenu = JSON.parse(value);
    } catch(e) {
    }
    this.menu = Array.isArray(storeMenu) ? storeMenu : []
  }
});

export default Store